export const GOOGLE_MAPS_API_KEY = 'AIzaSyARPpAFdpiSZy4yMZ9fJ9sjPiYlhhcS_Eo';
export const POPUP_CONTAINER_ID = 'paperpress_popup';
export const SNACKBAR_CONTAINER_ID = 'paperpress_snackbar';
export const API_NAMESPACE = '/api';
